import comp from "./DescriptionCell";
export default comp;
